// const io = require('socket.io-client');
import io from 'socket.io/client-dist/socket.io'

class WorldSocket {
  constructor() {
    this.socket = io(process.env.VUE_APP_SOCKET_URL);

    this.on = this.onMessage.bind(this)
  }

  onMessage(name, cb) {
    this.socket.on(name, (payload) => {
      cb(payload)
    });
  }
}

export default new WorldSocket()